module.exports = __webpack_public_path__ + "img/d24be5c.jpg";